import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { getHeaderHeight } from '../components/navigation/header/header.utils';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { BaseUnit } from '../../theming/baseUnitDefinition';

const componentConfigThemeKey = 'main';

interface MainTagThemeProps {
  baseUnit: BaseUnit
  backgroundColor: string
}

interface MainWrapperProps {
  isSecondaryHeaderEnabled: boolean
  noPadding?: boolean
  configThemeKey?: string
}

export const MainWrapperComponent: React.FunctionComponent<MainTagThemeProps & MainWrapperProps> = ({ baseUnit, backgroundColor, isSecondaryHeaderEnabled, noPadding, children }) => {
  const headerHeight = getHeaderHeight(isSecondaryHeaderEnabled);
  const horizontalPadding = noPadding ? 0 : 1;
  const style = {
    backgroundColor,
    paddingBottom: `${baseUnit}px`,
    [MEDIA_BREAKPOINTS.large]: {
      paddingTop: `${headerHeight + baseUnit / 4}px`,
      paddingLeft: `${baseUnit * horizontalPadding}px`,
      paddingRight: `${baseUnit * horizontalPadding}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingRight: `${baseUnit * 0.5 * horizontalPadding}px`,
      paddingLeft: `${baseUnit * 0.5 * horizontalPadding}px`,
      paddingTop: `${headerHeight + baseUnit / 4}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingRight: `${baseUnit * 0.5 * horizontalPadding}px`,
      paddingLeft: `${baseUnit * 0.5 * horizontalPadding}px`,
    },
    paddingTop: `${headerHeight + baseUnit / 4}px`,
  };

  return (
    <main
      className={css(StyleSheet.create({ style }).style)}
    >
      {children}
    </main>
  );
};

const mapThemeProps = (theme: MainTagThemeProps): MainTagThemeProps => ({
  baseUnit: theme.baseUnit,
  backgroundColor: theme.backgroundColor,
});

export const MainWrapper: React.FunctionComponent<MainWrapperProps> = props => {
  const { configThemeKey = componentConfigThemeKey } = props;
  const themeContext = useTheme(mapThemeProps, configThemeKey);
  return <MainWrapperComponent {...themeContext} {...props} />;
};
